export default __webpack_public_path__ + "static/sponsor-banner-bg-18f99909f5bb8fd98bbab8817f7e2f3a.png";